import createAxios from './api'

const PATH = 'rssp/v1/devices'

export default {
  async createDevice(req) {
    const axios = await createAxios()
    await axios.post(`${PATH}`, req)
  },

  async getDevice(id) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/${id}`)

    return resp.data
  },

  async listMyDevices(q, pageRequest) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/self`, {
      params: {
        q,
        ...pageRequest
      }
    })

    return resp.data
  },

  async listDevices(userId, q, pageRequest) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}`, {
      params: {
        userId,
        q,
        ...pageRequest
      }
    })

    return resp.data
  },

  async updateDevice(id, req) {
    const axios = await createAxios()
    await axios.put(`${PATH}/${id}`, req)
  },

  async deleteDevice(id) {
    const axios = await createAxios()
    await axios.delete(`${PATH}/${id}`)
  }
}
